module.exports = __webpack_public_path__ + "static/pic16-054fea178ad8f0a0d7ca094fa3ac5515.gif";